module.exports = __webpack_public_path__ + "img/im_scrollfeature_16@2x.f3097a6e.jpg";